import React, { useEffect, useState } from 'react';
import { Checkbox, Select } from 'antd';
import styled from 'styled-components';

import styles from './LimitParticipant.module.css';

interface SelectProps {
  id: string;
  placeholder: string;
  defaultValue: string;
  onChange: (value: any) => void;
  dropdownStyle?: {};
  mode?: 'multiple' | 'tags' | undefined;
}

export const LimitParticipant: React.FC<SelectProps> = ({
  id,
  placeholder,
  mode,
  defaultValue,
  dropdownStyle,
  onChange,
}) => {
  const [disable, setDisable] = useState<boolean>(true);
  const [checked, setChecked] = useState<boolean>(false);

  const getOptions = () => {
    const tab = [];
    for (let i = 2; i <= 50; i++) {
      tab.push(i);
    }
    return tab;
  };

  useEffect(() => {
    if (defaultValue) {
      setDisable(false);
      setChecked(true);
    }
    // eslint-disable-next-line
  }, []);

  return (
    <div className={styles.container}>
      <Checkbox
        style={{ marginRight: '8px' }}
        checked={checked}
        onChange={() => {
          setDisable(!disable);
          setChecked(!checked);
        }}
      />
      <p className={styles.label}>
        {placeholder} {checked && `à`}
      </p>
      {checked && (
        <StyledSelect
          placeholder=""
          size="large"
          id={id}
          defaultValue={defaultValue}
          disabled={disable}
          mode={mode}
          onChange={onChange}
          dropdownStyle={dropdownStyle}
          style={{ width: '58px' }}
        >
          {getOptions().map(v => {
            return (
              <StyledSelect.Option key={v} value={v}>
                {v}
              </StyledSelect.Option>
            );
          })}
        </StyledSelect>
      )}
    </div>
  );
};

const StyledSelect = styled(Select)`
  .ant-select-selector {
    height: 25px !important;
  }
  .ant-select-selection-item {
    line-height: 22px !important;
  }
`;
